var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1060FF;}\n\t.st1{fill:#0D86FF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M441.7,189.9L308,177.5L254.8,54.2c-3.7-8.6-16-8.6-19.7,0L182,177.5L48.3,189.9c-9.4,0.9-13.1,12.5-6.1,18.7 l100.9,88.6l-29.5,131c-2.1,9.2,7.8,16.4,15.9,11.6L245,371.3l115.5,68.6c8.1,4.8,18-2.4,15.9-11.6l-29.5-131l100.9-88.6 C454.9,202.5,451.1,190.8,441.7,189.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.2,99l-19.3-44.9c-3.7-8.6-16-8.6-19.7,0L182,177.5L48.3,189.9c-9.4,0.9-13.1,12.5-6.1,18.7l100.9,88.6 l-29.5,131c-2.1,9.2,7.8,16.4,15.9,11.6l15.4-9.1C170.1,267.7,240.9,147.9,274.2,99z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ef753bebe31597590671e4338f1317ef.svg";
export { ForwardRef as ReactComponent };